import { Country } from 'utils/constants'
import moment from 'moment/moment'

const orderedDate = new Date()

const PREVIEW_DATA_REPORT_AU = Object.freeze({
  countryCode: Country.AU,
  propertyAddress: '100 Sample Street, Sample Suburb, Sample State',
  integratorEmail: 'info@mail.com',
  integratorFullName: 'Smith & Smith',
  integratorPhone: '0123 456 789',
  recipientFullName: 'John Smith',
  orderedDate
})

const PREVIEW_DATA_REPORT_NZ = Object.freeze({
  countryCode: Country.NZ,
  propertyAddress: '100 Sample Street, Sample Suburb, Sample Region',
  integratorEmail: 'info@mail.com',
  integratorFullName: 'Smith & Smith',
  integratorPhone: '0123 456 789',
  recipientFullName: 'John Smith',
  orderedDate
})

const PREVIEW_DATA_MAP_PANEL = Object.freeze({
  coordinates: {
    latitude: -33.80459343, longitude: 151.2853355
  }
})

const PREVIEW_DATA_PHOTO_LIST = (publicUrl) => {
  const exterior = `${publicUrl}/assets/report-preview/sample-exterior-01.jpg`
  const outdoor = `${publicUrl}/assets/report-preview/sample-outdoor-01.jpg`
  const kitchen = `${publicUrl}/assets/report-preview/sample-kitchen-01.jpg`
  const dining = `${publicUrl}/assets/report-preview/sample-dining-01.jpg`
  const bedroom = `${publicUrl}/assets/report-preview/sample-bedroom.jpg`
  const floorplan = `${publicUrl}/assets/report-preview/sample-floorplan-01.jpg`

  return [
    {
      digitalAssetType: 'Image',
      isDefaultPhoto: true,
      largePhotoUrl: exterior,
      mediumPhotoUrl: exterior,
      thumbnailPhotoUrl: exterior,
      scanDate: '2019-09-05'
    },
    {
      digitalAssetType: 'Image',
      isDefaultPhoto: false,
      largePhotoUrl: outdoor,
      mediumPhotoUrl: outdoor,
      thumbnailPhotoUrl: outdoor,
      scanDate: '2019-09-05'
    },
    {
      digitalAssetType: 'Image',
      isDefaultPhoto: false,
      largePhotoUrl: kitchen,
      mediumPhotoUrl: kitchen,
      thumbnailPhotoUrl: kitchen,
      scanDate: '2019-09-05'
    },
    {
      digitalAssetType: 'Image',
      isDefaultPhoto: false,
      largePhotoUrl: dining,
      mediumPhotoUrl: dining,
      thumbnailPhotoUrl: dining,
      scanDate: '2019-09-05'
    },
    {
      digitalAssetType: 'Image',
      isDefaultPhoto: false,
      largePhotoUrl: bedroom,
      mediumPhotoUrl: bedroom,
      thumbnailPhotoUrl: bedroom,
      scanDate: '2019-09-05'
    },
    {
      digitalAssetType: 'Floor Plan',
      isDefaultPhoto: false,
      largePhotoUrl: floorplan,
      mediumPhotoUrl: floorplan,
      thumbnailPhotoUrl: floorplan,
      scanDate: '2019-09-05'
    }
  ]
}

const SAMPLE_VALUATION_DATE = moment().subtract(7, 'days')
const PREVIEW_DATA_VALUATION_ESTIMATE_AU = Object.freeze({
  estimatedValue: {
    confidence: 'HIGH',
    lowValue: 1280000,
    highValue: 1510000,
    estimate: 1390000,
    fsd: 11,
    valuationDate: SAMPLE_VALUATION_DATE
  },
  estimatedRental: {
    rentalAvmEstimate: 1000,
    rentalAvmEstimateFsdScore: 7,
    rentalAvmEstimateHigh: 1100,
    rentalAvmEstimateLow: 900,
    rentalAvmPeriod: 'W',
    rentalAvmRunDate: '2021-04-19T03:51:49.650Z',
    rentalAvmScore: 40,
    rentalAvmValuationDate: SAMPLE_VALUATION_DATE,
    rentalAvmYield: 3.2,
    rentalAvmYieldFsdScore: 11
  }
})

const PREVIEW_DATA_VALUATION_ESTIMATE_NZ = Object.freeze({
  ...PREVIEW_DATA_VALUATION_ESTIMATE_AU,
  estimatedValue: {
    ...PREVIEW_DATA_VALUATION_ESTIMATE_AU.estimatedValue,
    estimate: null
  }
})

const PREVIEW_DATA_PROPERTY_SUMMARY_AU = Object.freeze({
  propertyId: 0,
  location: {
    singleLine: '100 Sample Street, Suburb, Sample State',
    councilArea: 'Sample Council'
  },
  attrCore: {
    propertyType: 'House',
    baths: 2,
    beds: 2,
    carSpaces: 2,
    lockUpGarages: 1,
    isCalculatedLandArea: true,
    landArea: 2000,
    propertySubType: 'Lifestyle: Improved'
  },
  attrAdditional: {
    floorArea: 450,
    yearBuilt: '2016',
    wallMaterial: 'Weatherboard',
    roofMaterial: 'Steel/G-Iron'
  },
  site: {
    landUsePrimary: 'Single Unit Dwelling',
    zoneCodeLocal: '00',
    zoneDescriptionLocal: 'Not Zoned'
  },
  legalDetails: {
    displayName: 'Lot/Plan',
    displayValue: 'L123 RP123456'
  }
})

const PREVIEW_DATA_PROPERTY_SUMMARY_NZ = Object.freeze({
  ...PREVIEW_DATA_PROPERTY_SUMMARY_AU,
  location: {
    ...PREVIEW_DATA_PROPERTY_SUMMARY_AU.location,
    singleLine: '100 Sample Street, Suburb, Sample Region'
  }
})

const PREVIEW_DATA_PROPERTY_TIMELINE_AU = Object.freeze({
  yearBuilt: '1990',
  sold: [{
    soldPrice: 435000,
    dateOfSale: '2018-03-05',
    saleAdvisedBy: 'Sample Agency',
    saleMethod: 'Normal Sale',
    timelineDate: '2018-03-05',
    timelineType: 'SOLD'
  }],
  forSale: [{
    listingPrice: 'Not Disclosed',
    daysOnMarket: 15,
    dateOfListing: '2005-12-12',
    listingType: 'Auction: 22 July 2013, 06:00 PM',
    listedBy: 'Listed by John Smith of Sample Agency',
    timelineDate: '2005-12-12',
    timelineType: 'FOR SALE'
  }],
  forRent: [{
    rentPrice: 1100,
    rentPeriod: 'W',
    daysOnMarket: 9,
    dateOfListing: '2005-12-12',
    listedBy: 'Rented by Paul Smith of Sample Agency',
    timelineDate: '2005-12-12',
    timelineType: 'FOR RENT'
  }],
  developmentApplication: [{
    applicationType: 'GARAGE/SHEDS',
    buildValue: 10840,
    constructionType: 'Garage/Sheds',
    permitNumber: '123',
    buildArea: 163,
    timelineDate: '2005-12-12'
  }]
})

const PREVIEW_DATA_PROPERTY_TIMELINE_NZ = Object.freeze({
  yearBuilt: '1990',
  sold: [{
    soldPrice: 435000,
    dateOfSale: '2018-03-05',
    saleAdvisedBy: 'Sample Agency',
    saleMethod: 'Normal Sale',
    timelineDate: '2018-03-05',
    timelineType: 'SOLD'
  }],
  forSale: [{
    listingPrice: 'Not Disclosed',
    daysOnMarket: 15,
    dateOfListing: '2005-12-12',
    listingType: 'Auction: 22 July 2013, 06:00 PM',
    listedBy: 'Listed by John Smith of Sample Agency',
    timelineDate: '2005-12-12',
    timelineType: 'FOR SALE'
  }],
  ratingValuation: [{
    capitalValue: 350000,
    landValue: 200000,
    improvementValue: 150000,
    valuationDate: '2005-09-01',
    timelineDate: '2005-09-01',
    timelineType: 'RATING VALUATION'
  }],
  buildingConsent: [{
    buildValue: 2000,
    consentNumber: '00/1234',
    consentDate: '2008-05-01',
    consentType: 'Adds/Alts',
    timelineDate: '2008-05-01',
    timelineType: 'BUILDING CONSENT'
  }]
})

const PREVIEW_DATA_DISCLAIMER_AU = [{
  category: 'disclaimer',
  key: 'clData_au',
  content: 'The CoreLogic Data provided in this publication is of a general nature and should not be construed as specific advice or relied upon in lieu of appropriate professional advice.<br/><br>While CoreLogic uses commercially reasonable efforts to ensure the CoreLogic Data is current, CoreLogic does not warrant the accuracy, currency or completeness of the CoreLogic Data and to the full extent permitted by law excludes all loss or damage howsoever arising (including through negligence) in connection with the CoreLogic Data.'
}, {
  category: 'disclaimer',
  key: 'da_au',
  content: '<p>Any data or information containing development approval information (<b>Development Approval Data</b>) has been obtained from a variety of third party sources. The Development Approval Data:</p><p>(a)             is not available for all properties and/or may be incomplete in respect of certain properties and in particular, is only available for about 60 % of total building consents in Australia due to limitations with the collection of this data;</p><p>(b)             relies on the accuracy of the description against the Development Approval Data provided to CoreLogic by third parties;</p><p>(c)             may differ from the actual construction cost (where it contains an estimated construction cost) and</p><p>(d)             any errors in entry of property details may lead to incorrect Development Approval Data being provided and the recipient should always check the appropriateness of the information contained in the development approval report against the actual property or surrounding properties (including physical attributes of such property).</p>'
}, {
  category: 'disclaimer',
  key: 'map_anz',
  content: 'Any map that is produced is not intended or designed to replace the certificate of title or land survey information.  If you need a certificate of title or land survey information for any purpose then you can order these separately from CoreLogic or the relevant government body'
}, {
  category: 'disclaimer',
  key: 'nearmap',
  content: 'Aerial imagery has been sourced under agreement with Nearmap.'
}, {
  category: 'disclaimer',
  key: 'publicationPpr_au',
  content: 'This publication reproduces materials and content owned or licenced by RP Data Pty Ltd trading as CoreLogic Asia Pacific (CoreLogic) and may include data, statistics, estimates, indices, photographs, maps, tools, calculators (including their outputs), commentary, reports and other information (CoreLogic Data).'
}, {
  category: 'disclaimer',
  key: 'avmPpr_au',
  content: 'An Estimated Value is generated (i) by a computer driven mathematical model in reliance on available data; (ii) without the physical inspection of the subject property; (iii) without taking into account any market conditions (including building, planning, or economic), and/or (iv) without identifying observable features or risks (including adverse environmental issues, state of repair, improvements, renovations, aesthetics, views or aspect) which may, together or separately, affect the value. <br/>An Estimated Value is current only at the date of publication or supply.  CoreLogic expressly excludes any warranties and representations that an Estimated Value is an accurate representation as to the market value of the subject property.'
}, {
  category: 'disclaimer',
  key: 'cc_anz',
  content: 'Product Data licenced by CoreLogic under a Creative Commons Attribution licence. For details regarding licence, data source, copyright and disclaimers, see <a href=www.corelogic.com.au/aboutus/thirdpartyrestrictions.html>www.corelogic.com.au/aboutus/thirdpartyrestrictions.html</a>'
}, {
  category: 'disclaimer',
  key: 'school_au',
  content: 'Product Data licenced by CoreLogic under a Creative Commons Attribution licence. For details regarding licence, data source, copyright and disclaimers, see <a href=www.corelogic.com.au/aboutus/thirdpartyrestrictions.html>www.corelogic.com.au/aboutus/thirdpartyrestrictions.html</a>. All information relating to Schools provided by CoreLogic is as a courtesy only. CoreLogic does not make any representations regarding the accuracy or completeness of the data. You should contact the School directly to verify this information.'
}, {
  category: 'disclaimer',
  key: 'avm_au',
  content: 'An automated valuation model estimate (<b>AVM Estimate</b>) is a statistically derived estimate of the sale or rental value (as the context requires) of the subject property. An AVM Estimate is generated (i) by a computer driven mathematical model in reliance on available data; (ii) without the physical inspection of the subject property; (iii) without taking into account market conditions which may, together or separately, affect the value.<br><br/>An AVM Estimate is current only at the date of publication or supply and must not be relied upon as a professional valuation or an accurate representation of the market sale or rental value of the subject property.<br><br/>CoreLogic does not warrant the accuracy, currency or completeness of the AVM Estimate and to the full extent permitted by law, CoreLogic excludes all liability for any loss or damage howsoever arising in connection with an AVM Estimate.'
}, {
  category: 'disclaimer',
  key: 'avm_confidence',
  content: 'The Confidence is based on a statistical calculation as to the probability of the Estimated Value being accurate compared to market value. An Estimated Value with a ‘High‘ confidence is considered more reliable than an Estimated Value with a ‘Medium’ or ‘Low’ confidence. The Confidence is a reflection of the amount of data we have on the property and similar properties in the surrounding areas. Generally, the more data we have for the local real estate market and subject property, the higher the Confidence level will be. Confidence should be considered alongside the Estimated Value.'
}, {
  category: 'disclaimer',
  key: 'estimatedValueHowToRead_anz',
  content: 'The Confidence is based on a statistical calculation as to the probability of the Estimated Value being accurate compared to market value. An Estimated Value with a ‘High‘ confidence is considered more reliable than an Estimated Value with a ‘Medium’ or ‘Low’ confidence. The Confidence is a reflection of amount of data we have on the property and similar properties in the surrounding areas. Generally, the more data we have for the local real estate market and subject property, the higher the Confidence level will be.<br><br>Confidence should be considered alongside the Estimated Value.<br><br>Confidence is displayed as a coloured coded range with red representing low confidence, through to amber which represents medium confidence to green for higher confidence'
}, {
  category: 'disclaimer',
  key: 'stateNsw_au',
  content: 'Contains property sales information provided under licence from the Land and Property Information (“<b>LPI</b>”). RP Data Pty Ltd trading as CoreLogic is authorised as a Property Sales Information provider by the LPI.'
}]

const PREVIEW_DATA_DISCLAIMER_NZ = [{
  category: 'disclaimer',
  key: 'clData_nz',
  content: 'The CoreLogic Data provided in this publication is of a general nature and should not be construed as specific advice or relied upon in lieu of appropriate professional advice. <br><br>While CoreLogic uses commercially reasonable efforts to ensure the CoreLogic Data is current, CoreLogic does not warrant the accuracy, currency or completeness of the CoreLogic Data and to the full extent permitted by law excludes liability for any loss or damage howsoever arising (including through negligence) in connection with the CoreLogic Data.'
}, {
  category: 'disclaimer',
  key: 'map_anz',
  content: 'Any map that is produced is not intended or designed to replace the certificate of title or land survey information.  If you need a certificate of title or land survey information for any purpose then you can order these separately from CoreLogic or the relevant government body'
}, {
  category: 'disclaimer',
  key: 'nearmap',
  content: 'Aerial imagery has been sourced under agreement with Nearmap.'
}, {
  category: 'disclaimer',
  key: 'building_nz',
  content: '<p>Any data or information containing building consent information (<strong>Building Consent Data</strong>) has been obtained from a variety of third party sources.  The Building Consent Data:</p><p>(a) is not available for all properties and/or may be incomplete in respect of certain properties; </p><p>(b) relies on the accuracy of the description against the Building Consent Data provided to CoreLogic by third parties;</p><p>(c) may differ from the actual construction cost (where it contains an estimated construction cost) and</p><p>(d) any errors in entry of property details may lead to incorrect Building Consent Data being provided and the recipient should always check the appropriateness of the information contained in the building consent report against the actual property or surrounding properties (including physical attributes of such property).</p>'
}, {
  category: 'disclaimer',
  key: 'title_nz',
  content: 'Any data or information provided based on a Record of Title is a subset of information available from the relevant registering body and has not been changed in any way by CoreLogic. Such data and information is not a substitute for a Record of Title. The data and information is updated at regular intervals (promptly after receipt) but may be up to six weeks old. At any time, the data or information relating to a Record of Title may be superseded.'
}, {
  category: 'disclaimer',
  key: 'avm_anz',
  content: 'An automated valuation model estimate (<b>AVM Estimate</b>) is a statistically derived estimate of the sale or rental value (as the context requires) of the subject property. An AVM Estimate is generated (i) by a computer driven mathematical model in reliance on available data; (ii) without the physical inspection of the subject property; (iii) without taking into account market conditions which may, together or separately, affect the value.<br><br/>An AVM Estimate is current only at the date of publication or supply and must not be relied upon as a professional valuation or an accurate representation of the market sale or rental value of the subject property.<br><br/>CoreLogic does not warrant the accuracy, currency or completeness of the AVM Estimate and to the full extent permitted by law, CoreLogic excludes all liability for any loss or damage howsoever arising in connection with an AVM Estimate.'
}, {
  category: 'disclaimer',
  key: 'avmShort_nz',
  content: 'An automated valuation model estimate (Estimated Value) is a statistically derived estimate of the value of the subject property. An Estimated Value must not be relied upon as a professional valuation or an accurate representation of the market value of the subject property as determined by a valuer.'
}, {
  category: 'disclaimer',
  key: 'avmReport_nz',
  content: "An Estimated Value is generated (i) by a computer driven mathematical model in reliance on available data; (ii) without the physical inspection of the subject property; (iii) without taking into account any market conditions (including building, planning, or economic), and/or (iv) without identifying observable features or risks (including adverse environmental issues, state of repair, improvements, renovations, aesthetics, views or aspect) which may, together or separately, affect the value. <br><br>An Estimated Value is current only at the date of publication or supply.  CoreLogic expressly excludes any warranties and representations that an Estimated Value is an accurate representation as to the market value of the subject property. <br><br>To the full extent permitted by law, CoreLogic excludes all liability for any loss or damage howsoever arising or suffered by the recipient, whether as a result of the recipient's reliance on the accuracy of an Estimated Value or otherwise arising in connection with an Estimated Value."
}, {
  category: 'disclaimer',
  key: 'avm_confidence',
  content: 'The Confidence is based on a statistical calculation as to the probability of the Estimated Value being accurate compared to market value. An Estimated Value with a ‘High’ confidence is considered more reliable than an Estimated Value with a ‘Medium’ or ‘Low’ confidence. The Confidence is a reflection of the amount of data we have on the property and similar properties in the surrounding areas. Generally, the more data we have for the local real estate market and subject property, the higher the Confidence level will be. Confidence should be considered alongside the Estimated Value.'
}, {
  category: 'disclaimer',
  key: 'estimatedValueHowToRead_anz',
  content: 'The Confidence is based on a statistical calculation as to the probability of the Estimated Value being accurate compared to market value. An Estimated Value with a ’High’ confidence is considered more reliable than an Estimated Value with a ‘Medium’ or ‘Low’ confidence. The Confidence is a reflection of amount of data we have on the property and similar properties in the surrounding areas. Generally, the more data we have for the local real estate market and subject property, the higher the Confidence level will be.<br><br>Confidence should be considered alongside the Estimated Value.<br><br>Confidence is displayed as a coloured coded range with red representing low confidence, through to amber which represents medium confidence to green for higher confidence'
}]

const YEAR_TODAY = moment().year()
const PREVIEW_DATA_COPYRIGHT = [{
  category: 'copyright',
  key: 'clCopyrightFooter_au',
  content: `© Copyright ${YEAR_TODAY} | RP Data Pty Ltd trading as CoreLogic Asia Pacific (CoreLogic) and its licensors are the sole and exclusive owners of all rights, title and interest (including intellectual property rights) subsisting in this publication including any data, analytics, statistics and other information. All rights reserved. No reproduction, distribution, or transmission of the copyrighted materials is permitted. The information is deemed reliable but not guaranteed.`
}, {
  category: 'copyright',
  key: 'clCopyrightshort_au',
  content: `© Copyright ${YEAR_TODAY} RP Data Pty Ltd trading as CoreLogic Asia Pacific (CoreLogic).  All rights reserved.`
}, {
  category: 'copyright',
  key: 'clCopyright_au',
  content: `This publication reproduces materials and content owned or licenced by RP Data Pty Ltd trading as CoreLogic Asia Pacific (CoreLogic) and may include data, statistics, estimates, indices, photographs, maps, tools, calculators (including their outputs), commentary, reports and other information (CoreLogic Data).<br/>© Copyright ${YEAR_TODAY}. CoreLogic and its licensors are the sole and exclusive owners of all rights, title and interest (including intellectual property rights) the CoreLogic Data contained in this publication. All rights reserved.`
}, {
  category: 'copyright',
  key: 'clCopyright_nz',
  content: `This publication reproduces materials and content owned or licenced by CoreLogic NZ Limited (CoreLogic) and may include data, statistics, estimates, indices, photographs, maps, tools, calculators (including their outputs), commentary, reports and other information (CoreLogic Data).<br/>© Copyright ${YEAR_TODAY}. CoreLogic) and its licensors are the sole and exclusive owners of all rights, title and interest (including intellectual property rights) subsisting in this publication, including any data, analytics, statistics and other information contained in this publication. All rightsreserved.`
}]

const PREVIEW_DATA_COMPARABLES = (addressSuffix, publicUrl) => {
  const propertyPhotoList = [
    {
      url: `${publicUrl}/assets/report-preview/comparable-photo-1.jpg`,
      scanDate: '2019/11/30'
    },
    {
      url: `${publicUrl}/assets/report-preview/comparable-photo-2.jpg`,
      scanDate: '2019/11/30'
    }
  ]
  const thumbnailPhotoUrl = propertyPhotoList[0]

  return {
    recentlySold: [{
      propertyId: 1,
      singleLineAddress: `101 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      distanceFromTarget: 0.5,
      thumbnailPhotoUrl,
      yearBuilt: '1999',
      sales: {
        price: 1370000,
        contractDate: '2020-02-03',
        settlementDate: '2020-02-03',
        type: 'Auction',
        saleMethod: 'Auction',
        daysOnMarket: 200,
        isAgentsAdvice: false,
        isPriceWithheld: false,
        capitalValue: 740000
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    },
    {
      propertyId: 2,
      singleLineAddress: `102 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1970',
      distanceFromTarget: 0.5,
      thumbnailPhotoUrl,
      sales: {
        price: 1370000,
        contractDate: '2018-05-03',
        settlementDate: '2018-05-03',
        type: 'Unknown',
        saleMethod: 'Auction',
        isAgentsAdvice: false,
        isPriceWithheld: false,
        capitalValue: 750000,
        daysOnMarket: '201'
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }, {
      propertyId: 3,
      singleLineAddress: `103 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1970',
      distanceFromTarget: 0.5,
      thumbnailPhotoUrl,
      sales: {
        price: 1370000,
        contractDate: '2020-02-03',
        settlementDate: '2021-01-13',
        type: 'Unknown',
        saleMethod: 'Auction',
        isAgentsAdvice: false,
        isPriceWithheld: false,
        capitalValue: 1370000
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }],
    forSale: [{
      propertyId: 0,
      singleLineAddress: `101 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1963',
      distanceFromTarget: 0.0890237831530317,
      thumbnailPhotoUrl,
      sales: {
        firstPublishedPrice: 'Not Disclosed',
        firstAdvertisementPrice: 1000000,
        latestAdvertisementPrice: 1500000,
        listingMethod: 'By Negotiation',
        daysOnMarket: 31,
        fromDate: '2021-03-02',
        isActiveCampaign: true,
        priceDescription: 'Auction Guide $2,200,000',
        capitalValue: 1000000
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }, {
      propertyId: 1,
      singleLineAddress: `102 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1963',
      distanceFromTarget: 0.0890237831530317,
      thumbnailPhotoUrl,
      sales: {
        firstPublishedPrice: 'Not Disclosed',
        firstAdvertisementPrice: 1000000,
        latestAdvertisementPrice: 1500000,
        listingMethod: 'Asking Price',
        daysOnMarket: 200,
        fromDate: '2021-03-02',
        isActiveCampaign: true,
        priceDescription: 'Auction Guide $2,200,000',
        capitalValue: 1000000
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }, {
      propertyId: 3,
      singleLineAddress: `103 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1963',
      distanceFromTarget: 0.0890237831530317,
      thumbnailPhotoUrl,
      sales: {
        firstPublishedPrice: 'Not Disclosed',
        firstAdvertisementPrice: 1000000,
        latestAdvertisementPrice: 1500000,
        listingMethod: 'Enquiries Over',
        daysOnMarket: 50,
        fromDate: '2021-03-02',
        isActiveCampaign: true,
        priceDescription: 'Auction Guide $2,200,000',
        capitalValue: 150000
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }],
    forRent: [{
      propertyId: 0,
      singleLineAddress: `101 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1963',
      distanceFromTarget: 0.05,
      thumbnailPhotoUrl,
      sales: {
        price: 750,
        fromDate: '2020-10-23',
        priceDescription: '$750 Per Week',
        period: 'W',
        daysOnMarket: 200,
        toDate: '2021-02-18'
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }, {
      propertyId: 1,
      singleLineAddress: `102 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1963',
      distanceFromTarget: 0.05,
      thumbnailPhotoUrl,
      sales: {
        price: 750,
        fromDate: '2020-10-23',
        priceDescription: '$750 Per Week',
        period: 'W',
        daysOnMarket: 119,
        toDate: '2021-02-18'
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }, {
      propertyId: 2,
      singleLineAddress: `103 ${addressSuffix}`,
      state: 'NSW',
      bed: '2',
      bath: '2',
      car: '2',
      floorArea: '200',
      landArea: '200',
      calculatedLandArea: false,
      yearBuilt: '1963',
      distanceFromTarget: 0.05,
      thumbnailPhotoUrl,
      sales: {
        price: 750,
        fromDate: '2020-10-23',
        priceDescription: '$750 Per Week',
        period: 'W',
        daysOnMarket: 200,
        toDate: '2021-02-18'
      },
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      propertyPhotoList
    }]
  }
}

const PREVIEW_DATA_COMPARABLES_AU = (publicUrl) => {
  return PREVIEW_DATA_COMPARABLES('Sample Street, Suburb, Sample State', publicUrl)
}

const PREVIEW_DATA_COMPARABLES_NZ = (publicUrl) => {
  return PREVIEW_DATA_COMPARABLES('Sample Street, Suburb, Sample Region', publicUrl)
}

const PREVIEW_DATA_LOCAL_SCHOOL = {
  localSchools: [{
    schoolDetails: {
      placeSingleLineAddress: '102 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 1',
          schoolType: 'Primary',
          schoolGender: 'C',
          schoolSector: 'Government',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 145,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.5,
    placeType: 'school',
    targetInShape: true,
    placeId: 0
  }, {
    schoolDetails: {
      placeSingleLineAddress: '103 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 2',
          schoolType: 'Secondary',
          schoolGender: 'C',
          schoolSector: '',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 145,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.5,
    placeType: 'school',
    targetInShape: true,
    placeId: 1
  }, {
    schoolDetails: {
      placeSingleLineAddress: '104 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 3',
          schoolType: 'Combined',
          schoolGender: 'C',
          schoolSector: '',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 145,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.5,
    placeType: 'school',
    targetInShape: true,
    placeId: 2
  }, {
    schoolDetails: {
      placeSingleLineAddress: '105 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 4',
          schoolType: 'Special',
          schoolGender: 'C',
          schoolSector: '',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 145,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.5,
    placeType: 'school',
    targetInShape: true,
    placeId: 3
  },
  // nearby
  {
    schoolDetails: {
      placeSingleLineAddress: '92 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 6',
          schoolType: 'Primary',
          schoolGender: 'C',
          schoolSector: 'Government',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 100,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.1,
    placeType: 'school',
    targetInShape: false,
    placeId: 4
  }, {
    schoolDetails: {
      placeSingleLineAddress: '93 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 7',
          schoolType: 'Secondary',
          schoolGender: 'C',
          schoolSector: '',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 100,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.2,
    placeType: 'school',
    targetInShape: false,
    placeId: 5
  }, {
    schoolDetails: {
      placeSingleLineAddress: '94 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 8',
          schoolType: 'Secondary',
          schoolGender: 'C',
          schoolSector: '',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 150,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.3,
    placeType: 'school',
    targetInShape: false,
    placeId: 6
  }, {
    schoolDetails: {
      placeSingleLineAddress: '95 Sample Street, Suburb',
      placeMetaData: {
        school: [{
          schoolName: 'Sample School 9',
          schoolType: 'Secondary',
          schoolGender: 'C',
          schoolSector: '',
          schoolWebsite: '',
          schoolYearLow: '0',
          schoolYearHigh: '6',
          schoolEnrolments: 150,
          schoolGeographicRegion: ''
        }]
      }
    },
    hasShape: true,
    distanceFromTarget: 0.4,
    placeType: 'school',
    targetInShape: false,
    placeId: 7
  }]
}

const PREVIEW_DATA_RATING_VALUATION = Object.freeze({
  siteValueList: [{
    date: '2020-09-01',
    type: 'UCV',
    valuationNumber: '12345/12345',
    value: 200000
  }, {
    date: '2020-09-01',
    type: 'CV',
    valuationNumber: '12345/12345',
    value: 350000
  }, {
    date: '2020-09-01',
    type: 'IV',
    valuationNumber: '12345/12345',
    value: 150000
  }]
})

const PREVIEW_DATA_TITLE_DETAIL = Object.freeze({
  titles: [{
    titleDescription: {
      reference: 'AB123A/000',
      type: 'Freehold',
      issueDate: '1993-03-31',
      registerType: 'Computer Freehold Register',
      priorTitleReferences: ['AA1234/00']
    },
    legalDescriptions: [{
      description: 'Lot 1 Deposited Plan 12345',
      estateType: 'Fee Simple',
      estateShare: '1/1',
      totalArea: 3.5
    }]
  }]
})

const PREVIEW_DATA_MARKET_INSIGHT_1YR_AU = Object.freeze({
  data: {
    seriesResponseList: [{
      localityName: 'Sample Suburb',
      locationType: 'Sample',
      metricDisplayType: 'Dollar',
      metricType: 'Median Asking Rent (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 49,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-13.2%',
      seriesDataList: [{
        dateTime: '2019-09-30',
        value: 950.0
      }, {
        dateTime: '2019-10-31',
        value: 912.5
      }, {
        dateTime: '2019-11-30',
        value: 900.0
      }, {
        dateTime: '2019-12-31',
        value: 900.0
      }, {
        dateTime: '2020-01-31',
        value: 900.0
      }, {
        dateTime: '2020-02-29',
        value: 890.0
      }, {
        dateTime: '2020-03-31',
        value: 880.0
      }, {
        dateTime: '2020-04-30',
        value: 850.0
      }, {
        dateTime: '2020-05-31',
        value: 850.0
      }, {
        dateTime: '2020-06-30',
        value: 829.5
      }, {
        dateTime: '2020-07-31',
        value: 820.0
      }, {
        dateTime: '2020-08-31',
        value: 824.75
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Median Days on Market (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 32,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '39.3%',
      seriesDataList: [{
        dateTime: '2019-07-31',
        value: 42.0
      }, {
        dateTime: '2019-08-31',
        value: 46.0
      }, {
        dateTime: '2019-09-30',
        value: 47.0
      }, {
        dateTime: '2019-10-31',
        value: 48.0
      }, {
        dateTime: '2019-11-30',
        value: 79.0
      }, {
        dateTime: '2019-12-31',
        value: 79.0
      }, {
        dateTime: '2020-01-31',
        value: 79.0
      }, {
        dateTime: '2020-02-29',
        value: 84.0
      }, {
        dateTime: '2020-03-31',
        value: 84.0
      }, {
        dateTime: '2020-04-30',
        value: 79.0
      }, {
        dateTime: '2020-05-31',
        value: 84.0
      }, {
        dateTime: '2020-06-30',
        value: 58.5
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Median Value (monthly)',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 11,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '6.1%',
      seriesDataList: [{
        dateTime: '2019-09-30',
        value: 1763855.0096
      }, {
        dateTime: '2019-10-31',
        value: 1775299.6685
      }, {
        dateTime: '2019-11-30',
        value: 1986752.2167
      }, {
        dateTime: '2019-12-31',
        value: 2048000.4197
      }, {
        dateTime: '2020-01-31',
        value: 2063869.0575
      }, {
        dateTime: '2020-02-29',
        value: 2080664.1557
      }, {
        dateTime: '2020-03-31',
        value: 2047130.4843
      }, {
        dateTime: '2020-04-30',
        value: 2048067.7768
      }, {
        dateTime: '2020-05-31',
        value: 1970922.7234
      }, {
        dateTime: '2020-06-30',
        value: 1995608.5668
      }, {
        dateTime: '2020-07-31',
        value: 1895955.9548
      }, {
        dateTime: '2020-08-31',
        value: 1870714.9008
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Percent',
      metricType: 'Median Vendor Discount (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 20,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: 'n/a',
      seriesDataList: [{
        dateTime: '2018-08-31',
        value: -0.0350985221
      }, {
        dateTime: '2018-09-30',
        value: -0.0350985221
      }, {
        dateTime: '2018-10-31',
        value: -0.0389097744
      }, {
        dateTime: '2018-11-30',
        value: -0.0395308924
      }, {
        dateTime: '2018-12-31',
        value: -0.0395308924
      }, {
        dateTime: '2019-01-31',
        value: -0.0395308924
      }, {
        dateTime: '2019-03-31',
        value: -0.0665
      }, {
        dateTime: '2019-04-30',
        value: -0.0475526315
      }, {
        dateTime: '2019-05-31',
        value: -0.0475526315
      }, {
        dateTime: '2019-06-30',
        value: -0.0475526315
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Number Sold (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 37,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-14.5%',
      seriesDataList: [{
        dateTime: '2019-07-31',
        value: 69.0
      }, {
        dateTime: '2019-08-31',
        value: 68.0
      }, {
        dateTime: '2019-09-30',
        value: 64.0
      }, {
        dateTime: '2019-10-31',
        value: 60.0
      }, {
        dateTime: '2019-11-30',
        value: 65.0
      }, {
        dateTime: '2019-12-31',
        value: 62.0
      }, {
        dateTime: '2020-01-31',
        value: 65.0
      }, {
        dateTime: '2020-02-29',
        value: 66.0
      }, {
        dateTime: '2020-03-31',
        value: 61.0
      }, {
        dateTime: '2020-04-30',
        value: 59.0
      }, {
        dateTime: '2020-05-31',
        value: 59.0
      }, {
        dateTime: '2020-06-30',
        value: 59.0
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Percent',
      metricType: 'Value Based Gross Rental Yield',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 10,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-20.2%',
      seriesDataList: [{
        dateTime: '2019-09-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-10-31',
        value: 0.0311999999
      }, {
        dateTime: '2019-11-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-12-31',
        value: 0.03115
      }, {
        dateTime: '2020-01-31',
        value: 0.0302
      }, {
        dateTime: '2020-02-29',
        value: 0.0291
      }, {
        dateTime: '2020-03-31',
        value: 0.0281999999
      }, {
        dateTime: '2020-04-30',
        value: 0.02665
      }, {
        dateTime: '2020-05-31',
        value: 0.0254999999
      }, {
        dateTime: '2020-06-30',
        value: 0.0253999999
      }, {
        dateTime: '2020-07-31',
        value: 0.0252
      }, {
        dateTime: '2020-08-31',
        value: 0.0248999999
      }]
    }]
  },
  yearCount: 1
})

const PREVIEW_DATA_MARKET_INSIGHT_1YR_NZ = Object.freeze({
  data: {
    seriesResponseList: [{
      localityName: 'Sample Suburb',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Median Days on Market (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 75,
      propertyType: 'Houses',
      changePercentage: '-36.8%',
      seriesDataList: [{
        dateTime: '2019-09-30',
        value: 68.0
      }, {
        dateTime: '2019-10-31',
        value: 67.0
      }, {
        dateTime: '2019-11-30',
        value: 67.0
      }, {
        dateTime: '2019-12-31',
        value: 59.0
      }, {
        dateTime: '2020-01-31',
        value: 59.0
      }, {
        dateTime: '2020-02-29',
        value: 30.0
      }, {
        dateTime: '2020-03-31',
        value: 30.0
      }, {
        dateTime: '2020-04-30',
        value: 9.0
      }, {
        dateTime: '2020-05-31',
        value: 30.0
      }, {
        dateTime: '2020-06-30',
        value: 30.0
      }, {
        dateTime: '2020-07-31',
        value: 43.0
      }, {
        dateTime: '2020-08-31',
        value: 43.0
      }]
    }, {
      localityName: 'RAKAIA',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Number Sold (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 37,
      propertyType: 'Residential dwellings',
      changePercentage: '-45.9%',
      seriesDataList: [{
        dateTime: '2019-07-31',
        value: 37.0
      }, {
        dateTime: '2019-08-31',
        value: 27.0
      }, {
        dateTime: '2019-09-30',
        value: 37.0
      }, {
        dateTime: '2019-10-31',
        value: 31.0
      }, {
        dateTime: '2019-11-30',
        value: 26.0
      }, {
        dateTime: '2019-12-31',
        value: 29.0
      }, {
        dateTime: '2020-01-31',
        value: 26.0
      }, {
        dateTime: '2020-02-29',
        value: 27.0
      }, {
        dateTime: '2020-03-31',
        value: 24.0
      }, {
        dateTime: '2020-04-30',
        value: 22.0
      }, {
        dateTime: '2020-05-31',
        value: 20.0
      }, {
        dateTime: '2020-06-30',
        value: 20.0
      }]
    }, {
      localityName: 'RAKAIA',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Stratified Median Value (monthly)',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 73,
      propertyType: 'Residential dwellings',
      changePercentage: '4.6%',
      seriesDataList: [{
        dateTime: '2019-09-30',
        value: 322900.0
      }, {
        dateTime: '2019-10-31',
        value: 324750.0
      }, {
        dateTime: '2019-11-30',
        value: 321100.0
      }, {
        dateTime: '2019-12-31',
        value: 327350.0
      }, {
        dateTime: '2020-01-31',
        value: 327550.0
      }, {
        dateTime: '2020-02-29',
        value: 329950.0
      }, {
        dateTime: '2020-03-31',
        value: 330800.0
      }, {
        dateTime: '2020-04-30',
        value: 330350.0
      }, {
        dateTime: '2020-05-31',
        value: 332350.0
      }, {
        dateTime: '2020-06-30',
        value: 333100.0
      }, {
        dateTime: '2020-07-31',
        value: 334700.0
      }, {
        dateTime: '2020-08-31',
        value: 337750.0
      }]
    }]
  },
  yearCount: 1
})

const PREVIEW_DATA_MARKET_INSIGHT_AU = {
  3: {
    isError: false,
    isLoaded: true,
    loading: false,
    seriesResponseList: [{
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Median Asking Rent (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 49,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-11.6%',
      seriesDataList: [{
        dateTime: '2017-09-30',
        value: 932.5
      }, {
        dateTime: '2017-10-31',
        value: 950.0
      }, {
        dateTime: '2017-11-30',
        value: 950.0
      }, {
        dateTime: '2017-12-31',
        value: 950.0
      }, {
        dateTime: '2018-01-31',
        value: 970.0
      }, {
        dateTime: '2018-02-28',
        value: 1000.0
      }, {
        dateTime: '2018-03-31',
        value: 1000.0
      }, {
        dateTime: '2018-04-30',
        value: 995.0
      }, {
        dateTime: '2018-05-31',
        value: 990.0
      }, {
        dateTime: '2018-06-30',
        value: 997.5
      }, {
        dateTime: '2018-07-31',
        value: 990.0
      }, {
        dateTime: '2018-08-31',
        value: 975.0
      }, {
        dateTime: '2018-09-30',
        value: 992.5
      }, {
        dateTime: '2018-10-31',
        value: 990.0
      }, {
        dateTime: '2018-11-30',
        value: 990.0
      }, {
        dateTime: '2018-12-31',
        value: 990.0
      }, {
        dateTime: '2019-01-31',
        value: 980.0
      }, {
        dateTime: '2019-02-28',
        value: 962.5
      }, {
        dateTime: '2019-03-31',
        value: 950.0
      }, {
        dateTime: '2019-04-30',
        value: 990.0
      }, {
        dateTime: '2019-05-31',
        value: 990.0
      }, {
        dateTime: '2019-06-30',
        value: 950.0
      }, {
        dateTime: '2019-07-31',
        value: 990.0
      }, {
        dateTime: '2019-08-31',
        value: 990.0
      }, {
        dateTime: '2019-09-30',
        value: 950.0
      }, {
        dateTime: '2019-10-31',
        value: 912.5
      }, {
        dateTime: '2019-11-30',
        value: 900.0
      }, {
        dateTime: '2019-12-31',
        value: 900.0
      }, {
        dateTime: '2020-01-31',
        value: 900.0
      }, {
        dateTime: '2020-02-29',
        value: 890.0
      }, {
        dateTime: '2020-03-31',
        value: 880.0
      }, {
        dateTime: '2020-04-30',
        value: 850.0
      }, {
        dateTime: '2020-05-31',
        value: 850.0
      }, {
        dateTime: '2020-06-30',
        value: 829.5
      }, {
        dateTime: '2020-07-31',
        value: 820.0
      }, {
        dateTime: '2020-08-31',
        value: 824.75
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Median Days on Market (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 32,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '129.4%',
      seriesDataList: [{
        dateTime: '2017-07-31',
        value: 25.5
      }, {
        dateTime: '2017-08-31',
        value: 28.0
      }, {
        dateTime: '2017-09-30',
        value: 27.0
      }, {
        dateTime: '2017-10-31',
        value: 33.0
      }, {
        dateTime: '2017-11-30',
        value: 37.0
      }, {
        dateTime: '2017-12-31',
        value: 47.0
      }, {
        dateTime: '2018-01-31',
        value: 47.0
      }, {
        dateTime: '2018-02-28',
        value: 55.0
      }, {
        dateTime: '2018-03-31',
        value: 55.0
      }, {
        dateTime: '2018-04-30',
        value: 47.5
      }, {
        dateTime: '2018-05-31',
        value: 52.0
      }, {
        dateTime: '2018-06-30',
        value: 57.0
      }, {
        dateTime: '2018-07-31',
        value: 56.0
      }, {
        dateTime: '2018-08-31',
        value: 56.0
      }, {
        dateTime: '2018-09-30',
        value: 43.0
      }, {
        dateTime: '2018-10-31',
        value: 40.5
      }, {
        dateTime: '2018-11-30',
        value: 43.0
      }, {
        dateTime: '2018-12-31',
        value: 40.5
      }, {
        dateTime: '2019-01-31',
        value: 40.5
      }, {
        dateTime: '2019-02-28',
        value: 36.0
      }, {
        dateTime: '2019-03-31',
        value: 38.0
      }, {
        dateTime: '2019-04-30',
        value: 43.0
      }, {
        dateTime: '2019-05-31',
        value: 43.0
      }, {
        dateTime: '2019-06-30',
        value: 43.0
      }, {
        dateTime: '2019-07-31',
        value: 42.0
      }, {
        dateTime: '2019-08-31',
        value: 46.0
      }, {
        dateTime: '2019-09-30',
        value: 47.0
      }, {
        dateTime: '2019-10-31',
        value: 48.0
      }, {
        dateTime: '2019-11-30',
        value: 79.0
      }, {
        dateTime: '2019-12-31',
        value: 79.0
      }, {
        dateTime: '2020-01-31',
        value: 79.0
      }, {
        dateTime: '2020-02-29',
        value: 84.0
      }, {
        dateTime: '2020-03-31',
        value: 84.0
      }, {
        dateTime: '2020-04-30',
        value: 79.0
      }, {
        dateTime: '2020-05-31',
        value: 84.0
      }, {
        dateTime: '2020-06-30',
        value: 58.5
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Median Value (monthly)',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 11,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '1.9%',
      seriesDataList: [{
        dateTime: '2017-09-30',
        value: 1836096.4365
      }, {
        dateTime: '2017-10-31',
        value: 1804083.1056
      }, {
        dateTime: '2017-11-30',
        value: 1757901.3691
      }, {
        dateTime: '2017-12-31',
        value: 1727185.9017
      }, {
        dateTime: '2018-01-31',
        value: 1704650.6992
      }, {
        dateTime: '2018-02-28',
        value: 1722329.789
      }, {
        dateTime: '2018-03-31',
        value: 1769353.0529
      }, {
        dateTime: '2018-04-30',
        value: 1798164.4853
      }, {
        dateTime: '2018-05-31',
        value: 1788009.7903
      }, {
        dateTime: '2018-06-30',
        value: 1823668.9884
      }, {
        dateTime: '2018-07-31',
        value: 1834872.0458
      }, {
        dateTime: '2018-08-31',
        value: 1814194.891
      }, {
        dateTime: '2018-09-30',
        value: 1794257.2466
      }, {
        dateTime: '2018-10-31',
        value: 1681519.9372
      }, {
        dateTime: '2018-11-30',
        value: 1641201.5211
      }, {
        dateTime: '2018-12-31',
        value: 1626104.3845
      }, {
        dateTime: '2019-01-31',
        value: 1643158.929
      }, {
        dateTime: '2019-02-28',
        value: 1595746.2048
      }, {
        dateTime: '2019-03-31',
        value: 1537759.1734
      }, {
        dateTime: '2019-04-30',
        value: 1544941.4856
      }, {
        dateTime: '2019-05-31',
        value: 1590644.7073
      }, {
        dateTime: '2019-06-30',
        value: 1601630.1266
      }, {
        dateTime: '2019-07-31',
        value: 1655872.1135
      }, {
        dateTime: '2019-08-31',
        value: 1703036.2988
      }, {
        dateTime: '2019-09-30',
        value: 1763855.0096
      }, {
        dateTime: '2019-10-31',
        value: 1775299.6685
      }, {
        dateTime: '2019-11-30',
        value: 1986752.2167
      }, {
        dateTime: '2019-12-31',
        value: 2048000.4197
      }, {
        dateTime: '2020-01-31',
        value: 2063869.0575
      }, {
        dateTime: '2020-02-29',
        value: 2080664.1557
      }, {
        dateTime: '2020-03-31',
        value: 2047130.4843
      }, {
        dateTime: '2020-04-30',
        value: 2048067.7768
      }, {
        dateTime: '2020-05-31',
        value: 1970922.7234
      }, {
        dateTime: '2020-06-30',
        value: 1995608.5668
      }, {
        dateTime: '2020-07-31',
        value: 1895955.9548
      }, {
        dateTime: '2020-08-31',
        value: 1870714.9008
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Percent',
      metricType: 'Median Vendor Discount (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 20,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: 'n/a',
      seriesDataList: [{
        dateTime: '2016-07-31',
        value: -0.0294117647
      }, {
        dateTime: '2016-08-31',
        value: -0.0327614379
      }, {
        dateTime: '2016-09-30',
        value: -0.0380555555
      }, {
        dateTime: '2018-08-31',
        value: -0.0350985221
      }, {
        dateTime: '2018-09-30',
        value: -0.0350985221
      }, {
        dateTime: '2018-10-31',
        value: -0.0389097744
      }, {
        dateTime: '2018-11-30',
        value: -0.0395308924
      }, {
        dateTime: '2018-12-31',
        value: -0.0395308924
      }, {
        dateTime: '2019-01-31',
        value: -0.0395308924
      }, {
        dateTime: '2019-03-31',
        value: -0.0665
      }, {
        dateTime: '2019-04-30',
        value: -0.0475526315
      }, {
        dateTime: '2019-05-31',
        value: -0.0475526315
      }, {
        dateTime: '2019-06-30',
        value: -0.0475526315
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Number Sold (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 37,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-19.2%',
      seriesDataList: [{
        dateTime: '2017-07-31',
        value: 73.0
      }, {
        dateTime: '2017-08-31',
        value: 72.0
      }, {
        dateTime: '2017-09-30',
        value: 74.0
      }, {
        dateTime: '2017-10-31',
        value: 68.0
      }, {
        dateTime: '2017-11-30',
        value: 59.0
      }, {
        dateTime: '2017-12-31',
        value: 62.0
      }, {
        dateTime: '2018-01-31',
        value: 62.0
      }, {
        dateTime: '2018-02-28',
        value: 62.0
      }, {
        dateTime: '2018-03-31',
        value: 57.0
      }, {
        dateTime: '2018-04-30',
        value: 60.0
      }, {
        dateTime: '2018-05-31',
        value: 60.0
      }, {
        dateTime: '2018-06-30',
        value: 57.0
      }, {
        dateTime: '2018-07-31',
        value: 54.0
      }, {
        dateTime: '2018-08-31',
        value: 56.0
      }, {
        dateTime: '2018-09-30',
        value: 56.0
      }, {
        dateTime: '2018-10-31',
        value: 62.0
      }, {
        dateTime: '2018-11-30',
        value: 65.0
      }, {
        dateTime: '2018-12-31',
        value: 65.0
      }, {
        dateTime: '2019-01-31',
        value: 64.0
      }, {
        dateTime: '2019-02-28',
        value: 59.0
      }, {
        dateTime: '2019-03-31',
        value: 62.0
      }, {
        dateTime: '2019-04-30',
        value: 61.0
      }, {
        dateTime: '2019-05-31',
        value: 62.0
      }, {
        dateTime: '2019-06-30',
        value: 65.0
      }, {
        dateTime: '2019-07-31',
        value: 69.0
      }, {
        dateTime: '2019-08-31',
        value: 68.0
      }, {
        dateTime: '2019-09-30',
        value: 64.0
      }, {
        dateTime: '2019-10-31',
        value: 60.0
      }, {
        dateTime: '2019-11-30',
        value: 65.0
      }, {
        dateTime: '2019-12-31',
        value: 62.0
      }, {
        dateTime: '2020-01-31',
        value: 65.0
      }, {
        dateTime: '2020-02-29',
        value: 66.0
      }, {
        dateTime: '2020-03-31',
        value: 61.0
      }, {
        dateTime: '2020-04-30',
        value: 59.0
      }, {
        dateTime: '2020-05-31',
        value: 59.0
      }, {
        dateTime: '2020-06-30',
        value: 59.0
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Percent',
      metricType: 'Value Based Gross Rental Yield',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 10,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-11.4%',
      seriesDataList: [{
        dateTime: '2017-09-30',
        value: 0.0281
      }, {
        dateTime: '2017-10-31',
        value: 0.0281
      }, {
        dateTime: '2017-11-30',
        value: 0.0281
      }, {
        dateTime: '2017-12-31',
        value: 0.0281999999
      }, {
        dateTime: '2018-01-31',
        value: 0.02835
      }, {
        dateTime: '2018-02-28',
        value: 0.02875
      }, {
        dateTime: '2018-03-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-04-30',
        value: 0.0291499999
      }, {
        dateTime: '2018-05-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-06-30',
        value: 0.0291499999
      }, {
        dateTime: '2018-07-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-08-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-09-30',
        value: 0.0291
      }, {
        dateTime: '2018-10-31',
        value: 0.0290499999
      }, {
        dateTime: '2018-11-30',
        value: 0.0290499999
      }, {
        dateTime: '2018-12-31',
        value: 0.0290499999
      }, {
        dateTime: '2019-01-31',
        value: 0.0290499999
      }, {
        dateTime: '2019-02-28',
        value: 0.0290499999
      }, {
        dateTime: '2019-03-31',
        value: 0.0290499999
      }, {
        dateTime: '2019-04-30',
        value: 0.0298999999
      }, {
        dateTime: '2019-05-31',
        value: 0.03075
      }, {
        dateTime: '2019-06-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-07-31',
        value: 0.0311999999
      }, {
        dateTime: '2019-08-31',
        value: 0.0311999999
      }, {
        dateTime: '2019-09-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-10-31',
        value: 0.0311999999
      }, {
        dateTime: '2019-11-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-12-31',
        value: 0.03115
      }, {
        dateTime: '2020-01-31',
        value: 0.0302
      }, {
        dateTime: '2020-02-29',
        value: 0.0291
      }, {
        dateTime: '2020-03-31',
        value: 0.0281999999
      }, {
        dateTime: '2020-04-30',
        value: 0.02665
      }, {
        dateTime: '2020-05-31',
        value: 0.0254999999
      }, {
        dateTime: '2020-06-30',
        value: 0.0253999999
      }, {
        dateTime: '2020-07-31',
        value: 0.0252
      }, {
        dateTime: '2020-08-31',
        value: 0.0248999999
      }]
    }]
  },
  5: {
    isError: false,
    isLoaded: true,
    loading: false,
    seriesResponseList: [{
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Median Asking Rent (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 49,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-6.8%',
      seriesDataList: [{
        dateTime: '2015-09-30',
        value: 885.0
      }, {
        dateTime: '2015-10-31',
        value: 882.5
      }, {
        dateTime: '2015-11-30',
        value: 880.0
      }, {
        dateTime: '2015-12-31',
        value: 865.0
      }, {
        dateTime: '2016-01-31',
        value: 850.0
      }, {
        dateTime: '2016-02-29',
        value: 830.0
      }, {
        dateTime: '2016-03-31',
        value: 840.0
      }, {
        dateTime: '2016-04-30',
        value: 875.0
      }, {
        dateTime: '2016-05-31',
        value: 862.5
      }, {
        dateTime: '2016-06-30',
        value: 865.0
      }, {
        dateTime: '2016-07-31',
        value: 850.0
      }, {
        dateTime: '2016-08-31',
        value: 875.0
      }, {
        dateTime: '2016-09-30',
        value: 875.0
      }, {
        dateTime: '2016-10-31',
        value: 895.0
      }, {
        dateTime: '2016-11-30',
        value: 900.0
      }, {
        dateTime: '2016-12-31',
        value: 900.0
      }, {
        dateTime: '2017-01-31',
        value: 900.0
      }, {
        dateTime: '2017-02-28',
        value: 900.0
      }, {
        dateTime: '2017-03-31',
        value: 900.0
      }, {
        dateTime: '2017-04-30',
        value: 900.0
      }, {
        dateTime: '2017-05-31',
        value: 900.0
      }, {
        dateTime: '2017-06-30',
        value: 900.0
      }, {
        dateTime: '2017-07-31',
        value: 900.0
      }, {
        dateTime: '2017-08-31',
        value: 917.5
      }, {
        dateTime: '2017-09-30',
        value: 932.5
      }, {
        dateTime: '2017-10-31',
        value: 950.0
      }, {
        dateTime: '2017-11-30',
        value: 950.0
      }, {
        dateTime: '2017-12-31',
        value: 950.0
      }, {
        dateTime: '2018-01-31',
        value: 970.0
      }, {
        dateTime: '2018-02-28',
        value: 1000.0
      }, {
        dateTime: '2018-03-31',
        value: 1000.0
      }, {
        dateTime: '2018-04-30',
        value: 995.0
      }, {
        dateTime: '2018-05-31',
        value: 990.0
      }, {
        dateTime: '2018-06-30',
        value: 997.5
      }, {
        dateTime: '2018-07-31',
        value: 990.0
      }, {
        dateTime: '2018-08-31',
        value: 975.0
      }, {
        dateTime: '2018-09-30',
        value: 992.5
      }, {
        dateTime: '2018-10-31',
        value: 990.0
      }, {
        dateTime: '2018-11-30',
        value: 990.0
      }, {
        dateTime: '2018-12-31',
        value: 990.0
      }, {
        dateTime: '2019-01-31',
        value: 980.0
      }, {
        dateTime: '2019-02-28',
        value: 962.5
      }, {
        dateTime: '2019-03-31',
        value: 950.0
      }, {
        dateTime: '2019-04-30',
        value: 990.0
      }, {
        dateTime: '2019-05-31',
        value: 990.0
      }, {
        dateTime: '2019-06-30',
        value: 950.0
      }, {
        dateTime: '2019-07-31',
        value: 990.0
      }, {
        dateTime: '2019-08-31',
        value: 990.0
      }, {
        dateTime: '2019-09-30',
        value: 950.0
      }, {
        dateTime: '2019-10-31',
        value: 912.5
      }, {
        dateTime: '2019-11-30',
        value: 900.0
      }, {
        dateTime: '2019-12-31',
        value: 900.0
      }, {
        dateTime: '2020-01-31',
        value: 900.0
      }, {
        dateTime: '2020-02-29',
        value: 890.0
      }, {
        dateTime: '2020-03-31',
        value: 880.0
      }, {
        dateTime: '2020-04-30',
        value: 850.0
      }, {
        dateTime: '2020-05-31',
        value: 850.0
      }, {
        dateTime: '2020-06-30',
        value: 829.5
      }, {
        dateTime: '2020-07-31',
        value: 820.0
      }, {
        dateTime: '2020-08-31',
        value: 824.75
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Median Days on Market (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 32,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '67.1%',
      seriesDataList: [{
        dateTime: '2015-07-31',
        value: 35.0
      }, {
        dateTime: '2015-08-31',
        value: 37.5
      }, {
        dateTime: '2015-09-30',
        value: 41.0
      }, {
        dateTime: '2015-10-31',
        value: 42.0
      }, {
        dateTime: '2015-11-30',
        value: 42.0
      }, {
        dateTime: '2015-12-31',
        value: 49.5
      }, {
        dateTime: '2016-01-31',
        value: 48.0
      }, {
        dateTime: '2016-02-29',
        value: 48.0
      }, {
        dateTime: '2016-03-31',
        value: 49.5
      }, {
        dateTime: '2016-04-30',
        value: 44.0
      }, {
        dateTime: '2016-05-31',
        value: 48.0
      }, {
        dateTime: '2016-06-30',
        value: 44.0
      }, {
        dateTime: '2016-07-31',
        value: 50.0
      }, {
        dateTime: '2016-08-31',
        value: 49.0
      }, {
        dateTime: '2016-09-30',
        value: 50.5
      }, {
        dateTime: '2016-10-31',
        value: 44.0
      }, {
        dateTime: '2016-11-30',
        value: 36.0
      }, {
        dateTime: '2016-12-31',
        value: 29.5
      }, {
        dateTime: '2017-01-31',
        value: 29.5
      }, {
        dateTime: '2017-02-28',
        value: 29.5
      }, {
        dateTime: '2017-03-31',
        value: 28.0
      }, {
        dateTime: '2017-04-30',
        value: 28.5
      }, {
        dateTime: '2017-05-31',
        value: 28.0
      }, {
        dateTime: '2017-06-30',
        value: 27.0
      }, {
        dateTime: '2017-07-31',
        value: 25.5
      }, {
        dateTime: '2017-08-31',
        value: 28.0
      }, {
        dateTime: '2017-09-30',
        value: 27.0
      }, {
        dateTime: '2017-10-31',
        value: 33.0
      }, {
        dateTime: '2017-11-30',
        value: 37.0
      }, {
        dateTime: '2017-12-31',
        value: 47.0
      }, {
        dateTime: '2018-01-31',
        value: 47.0
      }, {
        dateTime: '2018-02-28',
        value: 55.0
      }, {
        dateTime: '2018-03-31',
        value: 55.0
      }, {
        dateTime: '2018-04-30',
        value: 47.5
      }, {
        dateTime: '2018-05-31',
        value: 52.0
      }, {
        dateTime: '2018-06-30',
        value: 57.0
      }, {
        dateTime: '2018-07-31',
        value: 56.0
      }, {
        dateTime: '2018-08-31',
        value: 56.0
      }, {
        dateTime: '2018-09-30',
        value: 43.0
      }, {
        dateTime: '2018-10-31',
        value: 40.5
      }, {
        dateTime: '2018-11-30',
        value: 43.0
      }, {
        dateTime: '2018-12-31',
        value: 40.5
      }, {
        dateTime: '2019-01-31',
        value: 40.5
      }, {
        dateTime: '2019-02-28',
        value: 36.0
      }, {
        dateTime: '2019-03-31',
        value: 38.0
      }, {
        dateTime: '2019-04-30',
        value: 43.0
      }, {
        dateTime: '2019-05-31',
        value: 43.0
      }, {
        dateTime: '2019-06-30',
        value: 43.0
      }, {
        dateTime: '2019-07-31',
        value: 42.0
      }, {
        dateTime: '2019-08-31',
        value: 46.0
      }, {
        dateTime: '2019-09-30',
        value: 47.0
      }, {
        dateTime: '2019-10-31',
        value: 48.0
      }, {
        dateTime: '2019-11-30',
        value: 79.0
      }, {
        dateTime: '2019-12-31',
        value: 79.0
      }, {
        dateTime: '2020-01-31',
        value: 79.0
      }, {
        dateTime: '2020-02-29',
        value: 84.0
      }, {
        dateTime: '2020-03-31',
        value: 84.0
      }, {
        dateTime: '2020-04-30',
        value: 79.0
      }, {
        dateTime: '2020-05-31',
        value: 84.0
      }, {
        dateTime: '2020-06-30',
        value: 58.5
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Median Value (monthly)',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 11,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '13.9%',
      seriesDataList: [{
        dateTime: '2015-09-30',
        value: 1642626.2753
      }, {
        dateTime: '2015-10-31',
        value: 1626391.2165
      }, {
        dateTime: '2015-11-30',
        value: 1587659.6999
      }, {
        dateTime: '2015-12-31',
        value: 1583366.6345
      }, {
        dateTime: '2016-01-31',
        value: 1585622.5396
      }, {
        dateTime: '2016-02-29',
        value: 1585827.3691
      }, {
        dateTime: '2016-03-31',
        value: 1590694.4588
      }, {
        dateTime: '2016-04-30',
        value: 1605824.55
      }, {
        dateTime: '2016-05-31',
        value: 1605580.7548
      }, {
        dateTime: '2016-06-30',
        value: 1632315.1487
      }, {
        dateTime: '2016-07-31',
        value: 1658955.5163
      }, {
        dateTime: '2016-08-31',
        value: 1699932.2883
      }, {
        dateTime: '2016-09-30',
        value: 1743846.5931
      }, {
        dateTime: '2016-10-31',
        value: 1762092.0158
      }, {
        dateTime: '2016-11-30',
        value: 1765584.1015
      }, {
        dateTime: '2016-12-31',
        value: 1793951.4492
      }, {
        dateTime: '2017-01-31',
        value: 1820470.7516
      }, {
        dateTime: '2017-02-28',
        value: 1857705.324
      }, {
        dateTime: '2017-03-31',
        value: 1930910.3387
      }, {
        dateTime: '2017-04-30',
        value: 1968868.2869
      }, {
        dateTime: '2017-05-31',
        value: 1965458.3751
      }, {
        dateTime: '2017-06-30',
        value: 1952852.7764
      }, {
        dateTime: '2017-07-31',
        value: 1879645.2079
      }, {
        dateTime: '2017-08-31',
        value: 1871119.1397
      }, {
        dateTime: '2017-09-30',
        value: 1836096.4365
      }, {
        dateTime: '2017-10-31',
        value: 1804083.1056
      }, {
        dateTime: '2017-11-30',
        value: 1757901.3691
      }, {
        dateTime: '2017-12-31',
        value: 1727185.9017
      }, {
        dateTime: '2018-01-31',
        value: 1704650.6992
      }, {
        dateTime: '2018-02-28',
        value: 1722329.789
      }, {
        dateTime: '2018-03-31',
        value: 1769353.0529
      }, {
        dateTime: '2018-04-30',
        value: 1798164.4853
      }, {
        dateTime: '2018-05-31',
        value: 1788009.7903
      }, {
        dateTime: '2018-06-30',
        value: 1823668.9884
      }, {
        dateTime: '2018-07-31',
        value: 1834872.0458
      }, {
        dateTime: '2018-08-31',
        value: 1814194.891
      }, {
        dateTime: '2018-09-30',
        value: 1794257.2466
      }, {
        dateTime: '2018-10-31',
        value: 1681519.9372
      }, {
        dateTime: '2018-11-30',
        value: 1641201.5211
      }, {
        dateTime: '2018-12-31',
        value: 1626104.3845
      }, {
        dateTime: '2019-01-31',
        value: 1643158.929
      }, {
        dateTime: '2019-02-28',
        value: 1595746.2048
      }, {
        dateTime: '2019-03-31',
        value: 1537759.1734
      }, {
        dateTime: '2019-04-30',
        value: 1544941.4856
      }, {
        dateTime: '2019-05-31',
        value: 1590644.7073
      }, {
        dateTime: '2019-06-30',
        value: 1601630.1266
      }, {
        dateTime: '2019-07-31',
        value: 1655872.1135
      }, {
        dateTime: '2019-08-31',
        value: 1703036.2988
      }, {
        dateTime: '2019-09-30',
        value: 1763855.0096
      }, {
        dateTime: '2019-10-31',
        value: 1775299.6685
      }, {
        dateTime: '2019-11-30',
        value: 1986752.2167
      }, {
        dateTime: '2019-12-31',
        value: 2048000.4197
      }, {
        dateTime: '2020-01-31',
        value: 2063869.0575
      }, {
        dateTime: '2020-02-29',
        value: 2080664.1557
      }, {
        dateTime: '2020-03-31',
        value: 2047130.4843
      }, {
        dateTime: '2020-04-30',
        value: 2048067.7768
      }, {
        dateTime: '2020-05-31',
        value: 1970922.7234
      }, {
        dateTime: '2020-06-30',
        value: 1995608.5668
      }, {
        dateTime: '2020-07-31',
        value: 1895955.9548
      }, {
        dateTime: '2020-08-31',
        value: 1870714.9008
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Percent',
      metricType: 'Median Vendor Discount (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 20,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: 'n/a',
      seriesDataList: [{
        dateTime: '2015-12-31',
        value: -0.040114379
      }, {
        dateTime: '2016-01-31',
        value: -0.040114379
      }, {
        dateTime: '2016-02-29',
        value: -0.040114379
      }, {
        dateTime: '2016-03-31',
        value: -0.0347222222
      }, {
        dateTime: '2016-04-30',
        value: -0.0347222222
      }, {
        dateTime: '2016-05-31',
        value: -0.031372549
      }, {
        dateTime: '2016-06-30',
        value: -0.0333333333
      }, {
        dateTime: '2016-07-31',
        value: -0.0294117647
      }, {
        dateTime: '2016-08-31',
        value: -0.0327614379
      }, {
        dateTime: '2016-09-30',
        value: -0.0380555555
      }, {
        dateTime: '2018-08-31',
        value: -0.0350985221
      }, {
        dateTime: '2018-09-30',
        value: -0.0350985221
      }, {
        dateTime: '2018-10-31',
        value: -0.0389097744
      }, {
        dateTime: '2018-11-30',
        value: -0.0395308924
      }, {
        dateTime: '2018-12-31',
        value: -0.0395308924
      }, {
        dateTime: '2019-01-31',
        value: -0.0395308924
      }, {
        dateTime: '2019-03-31',
        value: -0.0665
      }, {
        dateTime: '2019-04-30',
        value: -0.0475526315
      }, {
        dateTime: '2019-05-31',
        value: -0.0475526315
      }, {
        dateTime: '2019-06-30',
        value: -0.0475526315
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Number Sold (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 37,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-20.3%',
      seriesDataList: [{
        dateTime: '2015-07-31',
        value: 74.0
      }, {
        dateTime: '2015-08-31',
        value: 73.0
      }, {
        dateTime: '2015-09-30',
        value: 69.0
      }, {
        dateTime: '2015-10-31',
        value: 67.0
      }, {
        dateTime: '2015-11-30',
        value: 67.0
      }, {
        dateTime: '2015-12-31',
        value: 66.0
      }, {
        dateTime: '2016-01-31',
        value: 67.0
      }, {
        dateTime: '2016-02-29',
        value: 63.0
      }, {
        dateTime: '2016-03-31',
        value: 68.0
      }, {
        dateTime: '2016-04-30',
        value: 71.0
      }, {
        dateTime: '2016-05-31',
        value: 73.0
      }, {
        dateTime: '2016-06-30',
        value: 70.0
      }, {
        dateTime: '2016-07-31',
        value: 66.0
      }, {
        dateTime: '2016-08-31',
        value: 68.0
      }, {
        dateTime: '2016-09-30',
        value: 69.0
      }, {
        dateTime: '2016-10-31',
        value: 73.0
      }, {
        dateTime: '2016-11-30',
        value: 77.0
      }, {
        dateTime: '2016-12-31',
        value: 75.0
      }, {
        dateTime: '2017-01-31',
        value: 73.0
      }, {
        dateTime: '2017-02-28',
        value: 78.0
      }, {
        dateTime: '2017-03-31',
        value: 80.0
      }, {
        dateTime: '2017-04-30',
        value: 77.0
      }, {
        dateTime: '2017-05-31',
        value: 74.0
      }, {
        dateTime: '2017-06-30',
        value: 74.0
      }, {
        dateTime: '2017-07-31',
        value: 73.0
      }, {
        dateTime: '2017-08-31',
        value: 72.0
      }, {
        dateTime: '2017-09-30',
        value: 74.0
      }, {
        dateTime: '2017-10-31',
        value: 68.0
      }, {
        dateTime: '2017-11-30',
        value: 59.0
      }, {
        dateTime: '2017-12-31',
        value: 62.0
      }, {
        dateTime: '2018-01-31',
        value: 62.0
      }, {
        dateTime: '2018-02-28',
        value: 62.0
      }, {
        dateTime: '2018-03-31',
        value: 57.0
      }, {
        dateTime: '2018-04-30',
        value: 60.0
      }, {
        dateTime: '2018-05-31',
        value: 60.0
      }, {
        dateTime: '2018-06-30',
        value: 57.0
      }, {
        dateTime: '2018-07-31',
        value: 54.0
      }, {
        dateTime: '2018-08-31',
        value: 56.0
      }, {
        dateTime: '2018-09-30',
        value: 56.0
      }, {
        dateTime: '2018-10-31',
        value: 62.0
      }, {
        dateTime: '2018-11-30',
        value: 65.0
      }, {
        dateTime: '2018-12-31',
        value: 65.0
      }, {
        dateTime: '2019-01-31',
        value: 64.0
      }, {
        dateTime: '2019-02-28',
        value: 59.0
      }, {
        dateTime: '2019-03-31',
        value: 62.0
      }, {
        dateTime: '2019-04-30',
        value: 61.0
      }, {
        dateTime: '2019-05-31',
        value: 62.0
      }, {
        dateTime: '2019-06-30',
        value: 65.0
      }, {
        dateTime: '2019-07-31',
        value: 69.0
      }, {
        dateTime: '2019-08-31',
        value: 68.0
      }, {
        dateTime: '2019-09-30',
        value: 64.0
      }, {
        dateTime: '2019-10-31',
        value: 60.0
      }, {
        dateTime: '2019-11-30',
        value: 65.0
      }, {
        dateTime: '2019-12-31',
        value: 62.0
      }, {
        dateTime: '2020-01-31',
        value: 65.0
      }, {
        dateTime: '2020-02-29',
        value: 66.0
      }, {
        dateTime: '2020-03-31',
        value: 61.0
      }, {
        dateTime: '2020-04-30',
        value: 59.0
      }, {
        dateTime: '2020-05-31',
        value: 59.0
      }, {
        dateTime: '2020-06-30',
        value: 59.0
      }]
    }, {
      localityName: 'Darlinghurst',
      locationType: 'Locality',
      metricDisplayType: 'Percent',
      metricType: 'Value Based Gross Rental Yield',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 10,
      postcodeName: '2010',
      propertyType: 'Houses',
      changePercentage: '-28.3%',
      seriesDataList: [{
        dateTime: '2015-09-30',
        value: 0.03475
      }, {
        dateTime: '2015-10-31',
        value: 0.03425
      }, {
        dateTime: '2015-11-30',
        value: 0.03375
      }, {
        dateTime: '2015-12-31',
        value: 0.0335
      }, {
        dateTime: '2016-01-31',
        value: 0.03325
      }, {
        dateTime: '2016-02-29',
        value: 0.03325
      }, {
        dateTime: '2016-03-31',
        value: 0.03325
      }, {
        dateTime: '2016-04-30',
        value: 0.03325
      }, {
        dateTime: '2016-05-31',
        value: 0.03325
      }, {
        dateTime: '2016-06-30',
        value: 0.0332
      }, {
        dateTime: '2016-07-31',
        value: 0.0332
      }, {
        dateTime: '2016-08-31',
        value: 0.0332
      }, {
        dateTime: '2016-09-30',
        value: 0.0332
      }, {
        dateTime: '2016-10-31',
        value: 0.0332
      }, {
        dateTime: '2016-11-30',
        value: 0.03295
      }, {
        dateTime: '2016-12-31',
        value: 0.03155
      }, {
        dateTime: '2017-01-31',
        value: 0.0298999999
      }, {
        dateTime: '2017-02-28',
        value: 0.0291499999
      }, {
        dateTime: '2017-03-31',
        value: 0.02875
      }, {
        dateTime: '2017-04-30',
        value: 0.0285499999
      }, {
        dateTime: '2017-05-31',
        value: 0.0282999999
      }, {
        dateTime: '2017-06-30',
        value: 0.0281999999
      }, {
        dateTime: '2017-07-31',
        value: 0.0281
      }, {
        dateTime: '2017-08-31',
        value: 0.0281
      }, {
        dateTime: '2017-09-30',
        value: 0.0281
      }, {
        dateTime: '2017-10-31',
        value: 0.0281
      }, {
        dateTime: '2017-11-30',
        value: 0.0281
      }, {
        dateTime: '2017-12-31',
        value: 0.0281999999
      }, {
        dateTime: '2018-01-31',
        value: 0.02835
      }, {
        dateTime: '2018-02-28',
        value: 0.02875
      }, {
        dateTime: '2018-03-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-04-30',
        value: 0.0291499999
      }, {
        dateTime: '2018-05-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-06-30',
        value: 0.0291499999
      }, {
        dateTime: '2018-07-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-08-31',
        value: 0.0291499999
      }, {
        dateTime: '2018-09-30',
        value: 0.0291
      }, {
        dateTime: '2018-10-31',
        value: 0.0290499999
      }, {
        dateTime: '2018-11-30',
        value: 0.0290499999
      }, {
        dateTime: '2018-12-31',
        value: 0.0290499999
      }, {
        dateTime: '2019-01-31',
        value: 0.0290499999
      }, {
        dateTime: '2019-02-28',
        value: 0.0290499999
      }, {
        dateTime: '2019-03-31',
        value: 0.0290499999
      }, {
        dateTime: '2019-04-30',
        value: 0.0298999999
      }, {
        dateTime: '2019-05-31',
        value: 0.03075
      }, {
        dateTime: '2019-06-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-07-31',
        value: 0.0311999999
      }, {
        dateTime: '2019-08-31',
        value: 0.0311999999
      }, {
        dateTime: '2019-09-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-10-31',
        value: 0.0311999999
      }, {
        dateTime: '2019-11-30',
        value: 0.0311999999
      }, {
        dateTime: '2019-12-31',
        value: 0.03115
      }, {
        dateTime: '2020-01-31',
        value: 0.0302
      }, {
        dateTime: '2020-02-29',
        value: 0.0291
      }, {
        dateTime: '2020-03-31',
        value: 0.0281999999
      }, {
        dateTime: '2020-04-30',
        value: 0.02665
      }, {
        dateTime: '2020-05-31',
        value: 0.0254999999
      }, {
        dateTime: '2020-06-30',
        value: 0.0253999999
      }, {
        dateTime: '2020-07-31',
        value: 0.0252
      }, {
        dateTime: '2020-08-31',
        value: 0.0248999999
      }]
    }]
  }
}

const PREVIEW_DATA_MARKET_INSIGHT_NZ = {
  3: {
    isError: false,
    isLoaded: true,
    loading: false,
    seriesResponseList: [{
      localityName: 'RAKAIA',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Median Days on Market (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 75,
      propertyType: 'Residential dwellings',
      changePercentage: '0.0%',
      seriesDataList: [{
        dateTime: '2017-09-30',
        value: 43.0
      }, {
        dateTime: '2017-10-31',
        value: 43.0
      }, {
        dateTime: '2017-11-30',
        value: 55.0
      }, {
        dateTime: '2017-12-31',
        value: 68.0
      }, {
        dateTime: '2018-01-31',
        value: 56.0
      }, {
        dateTime: '2018-02-28',
        value: 68.0
      }, {
        dateTime: '2018-03-31',
        value: 68.0
      }, {
        dateTime: '2018-04-30',
        value: 92.0
      }, {
        dateTime: '2018-05-31',
        value: 55.0
      }, {
        dateTime: '2018-06-30',
        value: 56.0
      }, {
        dateTime: '2018-07-31',
        value: 68.0
      }, {
        dateTime: '2018-08-31',
        value: 92.0
      }, {
        dateTime: '2018-09-30',
        value: 69.0
      }, {
        dateTime: '2018-10-31',
        value: 92.0
      }, {
        dateTime: '2018-11-30',
        value: 95.0
      }, {
        dateTime: '2018-12-31',
        value: 69.0
      }, {
        dateTime: '2019-01-31',
        value: 103.0
      }, {
        dateTime: '2019-02-28',
        value: 103.0
      }, {
        dateTime: '2019-03-31',
        value: 103.0
      }, {
        dateTime: '2019-04-30',
        value: 103.0
      }, {
        dateTime: '2019-05-31',
        value: 105.0
      }, {
        dateTime: '2019-06-30',
        value: 103.0
      }, {
        dateTime: '2019-07-31',
        value: 103.0
      }, {
        dateTime: '2019-08-31',
        value: 68.0
      }, {
        dateTime: '2019-09-30',
        value: 68.0
      }, {
        dateTime: '2019-10-31',
        value: 67.0
      }, {
        dateTime: '2019-11-30',
        value: 67.0
      }, {
        dateTime: '2019-12-31',
        value: 59.0
      }, {
        dateTime: '2020-01-31',
        value: 59.0
      }, {
        dateTime: '2020-02-29',
        value: 30.0
      }, {
        dateTime: '2020-03-31',
        value: 30.0
      }, {
        dateTime: '2020-04-30',
        value: 9.0
      }, {
        dateTime: '2020-05-31',
        value: 30.0
      }, {
        dateTime: '2020-06-30',
        value: 30.0
      }, {
        dateTime: '2020-07-31',
        value: 43.0
      }, {
        dateTime: '2020-08-31',
        value: 43.0
      }]
    }, {
      localityName: 'RAKAIA',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Number Sold (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 37,
      propertyType: 'Residential dwellings',
      changePercentage: '-47.4%',
      seriesDataList: [{
        dateTime: '2017-07-31',
        value: 38.0
      }, {
        dateTime: '2017-08-31',
        value: 38.0
      }, {
        dateTime: '2017-09-30',
        value: 43.0
      }, {
        dateTime: '2017-10-31',
        value: 37.0
      }, {
        dateTime: '2017-11-30',
        value: 37.0
      }, {
        dateTime: '2017-12-31',
        value: 38.0
      }, {
        dateTime: '2018-01-31',
        value: 37.0
      }, {
        dateTime: '2018-02-28',
        value: 36.0
      }, {
        dateTime: '2018-03-31',
        value: 37.0
      }, {
        dateTime: '2018-04-30',
        value: 36.0
      }, {
        dateTime: '2018-05-31',
        value: 36.0
      }, {
        dateTime: '2018-06-30',
        value: 38.0
      }, {
        dateTime: '2018-07-31',
        value: 39.0
      }, {
        dateTime: '2018-08-31',
        value: 33.0
      }, {
        dateTime: '2018-09-30',
        value: 43.0
      }, {
        dateTime: '2018-10-31',
        value: 39.0
      }, {
        dateTime: '2018-11-30',
        value: 42.0
      }, {
        dateTime: '2018-12-31',
        value: 40.0
      }, {
        dateTime: '2019-01-31',
        value: 42.0
      }, {
        dateTime: '2019-02-28',
        value: 42.0
      }, {
        dateTime: '2019-03-31',
        value: 43.0
      }, {
        dateTime: '2019-04-30',
        value: 42.0
      }, {
        dateTime: '2019-05-31',
        value: 42.0
      }, {
        dateTime: '2019-06-30',
        value: 40.0
      }, {
        dateTime: '2019-07-31',
        value: 37.0
      }, {
        dateTime: '2019-08-31',
        value: 27.0
      }, {
        dateTime: '2019-09-30',
        value: 37.0
      }, {
        dateTime: '2019-10-31',
        value: 31.0
      }, {
        dateTime: '2019-11-30',
        value: 26.0
      }, {
        dateTime: '2019-12-31',
        value: 29.0
      }, {
        dateTime: '2020-01-31',
        value: 26.0
      }, {
        dateTime: '2020-02-29',
        value: 27.0
      }, {
        dateTime: '2020-03-31',
        value: 24.0
      }, {
        dateTime: '2020-04-30',
        value: 22.0
      }, {
        dateTime: '2020-05-31',
        value: 20.0
      }, {
        dateTime: '2020-06-30',
        value: 20.0
      }]
    }, {
      localityName: 'RAKAIA',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Stratified Median Value (monthly)',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 73,
      propertyType: 'Residential dwellings',
      changePercentage: '6.4%',
      seriesDataList: [{
        dateTime: '2017-09-30',
        value: 317500.0
      }, {
        dateTime: '2017-10-31',
        value: 314050.0
      }, {
        dateTime: '2017-11-30',
        value: 314500.0
      }, {
        dateTime: '2017-12-31',
        value: 307050.0
      }, {
        dateTime: '2018-01-31',
        value: 304200.0
      }, {
        dateTime: '2018-02-28',
        value: 306150.0
      }, {
        dateTime: '2018-03-31',
        value: 307700.0
      }, {
        dateTime: '2018-04-30',
        value: 307700.0
      }, {
        dateTime: '2018-05-31',
        value: 308950.0
      }, {
        dateTime: '2018-06-30',
        value: 309950.0
      }, {
        dateTime: '2018-07-31',
        value: 309500.0
      }, {
        dateTime: '2018-08-31',
        value: 311350.0
      }, {
        dateTime: '2018-09-30',
        value: 314650.0
      }, {
        dateTime: '2018-10-31',
        value: 315100.0
      }, {
        dateTime: '2018-11-30',
        value: 315800.0
      }, {
        dateTime: '2018-12-31',
        value: 317550.0
      }, {
        dateTime: '2019-01-31',
        value: 320050.0
      }, {
        dateTime: '2019-02-28',
        value: 322350.0
      }, {
        dateTime: '2019-03-31',
        value: 324250.0
      }, {
        dateTime: '2019-04-30',
        value: 325850.0
      }, {
        dateTime: '2019-05-31',
        value: 327800.0
      }, {
        dateTime: '2019-06-30',
        value: 327450.0
      }, {
        dateTime: '2019-07-31',
        value: 325800.0
      }, {
        dateTime: '2019-08-31',
        value: 326500.0
      }, {
        dateTime: '2019-09-30',
        value: 322900.0
      }, {
        dateTime: '2019-10-31',
        value: 324750.0
      }, {
        dateTime: '2019-11-30',
        value: 321100.0
      }, {
        dateTime: '2019-12-31',
        value: 327350.0
      }, {
        dateTime: '2020-01-31',
        value: 327550.0
      }, {
        dateTime: '2020-02-29',
        value: 329950.0
      }, {
        dateTime: '2020-03-31',
        value: 330800.0
      }, {
        dateTime: '2020-04-30',
        value: 330350.0
      }, {
        dateTime: '2020-05-31',
        value: 332350.0
      }, {
        dateTime: '2020-06-30',
        value: 333100.0
      }, {
        dateTime: '2020-07-31',
        value: 334700.0
      }, {
        dateTime: '2020-08-31',
        value: 337750.0
      }]
    }]
  },
  5: {
    isError: false,
    isLoaded: true,
    loading: false,
    seriesResponseList: [{
      localityName: 'Sample Suburb',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Median Days on Market (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 75,
      propertyType: 'Residential dwellings',
      changePercentage: '-6.5%',
      seriesDataList: [{
        dateTime: '2016-09-30',
        value: 46.0
      }, {
        dateTime: '2016-10-31',
        value: 45.0
      }, {
        dateTime: '2016-11-30',
        value: 45.0
      }, {
        dateTime: '2016-12-31',
        value: 45.0
      }, {
        dateTime: '2017-01-31',
        value: 45.0
      }, {
        dateTime: '2017-02-28',
        value: 39.0
      }, {
        dateTime: '2017-03-31',
        value: 32.0
      }, {
        dateTime: '2017-04-30',
        value: 32.0
      }, {
        dateTime: '2017-05-31',
        value: 32.0
      }, {
        dateTime: '2017-06-30',
        value: 32.0
      }, {
        dateTime: '2017-07-31',
        value: 43.0
      }, {
        dateTime: '2017-08-31',
        value: 32.0
      }, {
        dateTime: '2017-09-30',
        value: 43.0
      }, {
        dateTime: '2017-10-31',
        value: 43.0
      }, {
        dateTime: '2017-11-30',
        value: 55.0
      }, {
        dateTime: '2017-12-31',
        value: 68.0
      }, {
        dateTime: '2018-01-31',
        value: 56.0
      }, {
        dateTime: '2018-02-28',
        value: 68.0
      }, {
        dateTime: '2018-03-31',
        value: 68.0
      }, {
        dateTime: '2018-04-30',
        value: 92.0
      }, {
        dateTime: '2018-05-31',
        value: 55.0
      }, {
        dateTime: '2018-06-30',
        value: 56.0
      }, {
        dateTime: '2018-07-31',
        value: 68.0
      }, {
        dateTime: '2018-08-31',
        value: 92.0
      }, {
        dateTime: '2018-09-30',
        value: 69.0
      }, {
        dateTime: '2018-10-31',
        value: 92.0
      }, {
        dateTime: '2018-11-30',
        value: 95.0
      }, {
        dateTime: '2018-12-31',
        value: 69.0
      }, {
        dateTime: '2019-01-31',
        value: 103.0
      }, {
        dateTime: '2019-02-28',
        value: 103.0
      }, {
        dateTime: '2019-03-31',
        value: 103.0
      }, {
        dateTime: '2019-04-30',
        value: 103.0
      }, {
        dateTime: '2019-05-31',
        value: 105.0
      }, {
        dateTime: '2019-06-30',
        value: 103.0
      }, {
        dateTime: '2019-07-31',
        value: 103.0
      }, {
        dateTime: '2019-08-31',
        value: 68.0
      }, {
        dateTime: '2019-09-30',
        value: 68.0
      }, {
        dateTime: '2019-10-31',
        value: 67.0
      }, {
        dateTime: '2019-11-30',
        value: 67.0
      }, {
        dateTime: '2019-12-31',
        value: 59.0
      }, {
        dateTime: '2020-01-31',
        value: 59.0
      }, {
        dateTime: '2020-02-29',
        value: 30.0
      }, {
        dateTime: '2020-03-31',
        value: 30.0
      }, {
        dateTime: '2020-04-30',
        value: 9.0
      }, {
        dateTime: '2020-05-31',
        value: 30.0
      }, {
        dateTime: '2020-06-30',
        value: 30.0
      }, {
        dateTime: '2020-07-31',
        value: 43.0
      }, {
        dateTime: '2020-08-31',
        value: 43.0
      }]
    }, {
      localityName: 'RAKAIA',
      locationType: 'Locality',
      metricDisplayType: 'Number',
      metricType: 'Number Sold (12 months)',
      metricTypeDescription: 'Statistics are calculated over a rolling 12 month period',
      metricTypeId: 37,
      propertyType: 'Residential dwellings',
      changePercentage: '-31.0%',
      seriesDataList: [{
        dateTime: '2015-07-31',
        value: 29.0
      }, {
        dateTime: '2015-08-31',
        value: 29.0
      }, {
        dateTime: '2015-09-30',
        value: 31.0
      }, {
        dateTime: '2015-10-31',
        value: 34.0
      }, {
        dateTime: '2015-11-30',
        value: 38.0
      }, {
        dateTime: '2015-12-31',
        value: 36.0
      }, {
        dateTime: '2016-01-31',
        value: 36.0
      }, {
        dateTime: '2016-02-29',
        value: 39.0
      }, {
        dateTime: '2016-03-31',
        value: 37.0
      }, {
        dateTime: '2016-04-30',
        value: 35.0
      }, {
        dateTime: '2016-05-31',
        value: 39.0
      }, {
        dateTime: '2016-06-30',
        value: 37.0
      }, {
        dateTime: '2016-07-31',
        value: 37.0
      }, {
        dateTime: '2016-08-31',
        value: 32.0
      }, {
        dateTime: '2016-09-30',
        value: 45.0
      }, {
        dateTime: '2016-10-31',
        value: 39.0
      }, {
        dateTime: '2016-11-30',
        value: 38.0
      }, {
        dateTime: '2016-12-31',
        value: 41.0
      }, {
        dateTime: '2017-01-31',
        value: 41.0
      }, {
        dateTime: '2017-02-28',
        value: 37.0
      }, {
        dateTime: '2017-03-31',
        value: 37.0
      }, {
        dateTime: '2017-04-30',
        value: 39.0
      }, {
        dateTime: '2017-05-31',
        value: 37.0
      }, {
        dateTime: '2017-06-30',
        value: 38.0
      }, {
        dateTime: '2017-07-31',
        value: 38.0
      }, {
        dateTime: '2017-08-31',
        value: 38.0
      }, {
        dateTime: '2017-09-30',
        value: 43.0
      }, {
        dateTime: '2017-10-31',
        value: 37.0
      }, {
        dateTime: '2017-11-30',
        value: 37.0
      }, {
        dateTime: '2017-12-31',
        value: 38.0
      }, {
        dateTime: '2018-01-31',
        value: 37.0
      }, {
        dateTime: '2018-02-28',
        value: 36.0
      }, {
        dateTime: '2018-03-31',
        value: 37.0
      }, {
        dateTime: '2018-04-30',
        value: 36.0
      }, {
        dateTime: '2018-05-31',
        value: 36.0
      }, {
        dateTime: '2018-06-30',
        value: 38.0
      }, {
        dateTime: '2018-07-31',
        value: 39.0
      }, {
        dateTime: '2018-08-31',
        value: 33.0
      }, {
        dateTime: '2018-09-30',
        value: 43.0
      }, {
        dateTime: '2018-10-31',
        value: 39.0
      }, {
        dateTime: '2018-11-30',
        value: 42.0
      }, {
        dateTime: '2018-12-31',
        value: 40.0
      }, {
        dateTime: '2019-01-31',
        value: 42.0
      }, {
        dateTime: '2019-02-28',
        value: 42.0
      }, {
        dateTime: '2019-03-31',
        value: 43.0
      }, {
        dateTime: '2019-04-30',
        value: 42.0
      }, {
        dateTime: '2019-05-31',
        value: 42.0
      }, {
        dateTime: '2019-06-30',
        value: 40.0
      }, {
        dateTime: '2019-07-31',
        value: 37.0
      }, {
        dateTime: '2019-08-31',
        value: 27.0
      }, {
        dateTime: '2019-09-30',
        value: 37.0
      }, {
        dateTime: '2019-10-31',
        value: 31.0
      }, {
        dateTime: '2019-11-30',
        value: 26.0
      }, {
        dateTime: '2019-12-31',
        value: 29.0
      }, {
        dateTime: '2020-01-31',
        value: 26.0
      }, {
        dateTime: '2020-02-29',
        value: 27.0
      }, {
        dateTime: '2020-03-31',
        value: 24.0
      }, {
        dateTime: '2020-04-30',
        value: 22.0
      }, {
        dateTime: '2020-05-31',
        value: 20.0
      }, {
        dateTime: '2020-06-30',
        value: 20.0
      }]
    }, {
      localityName: 'RAKAIA',
      locationType: 'Locality',
      metricDisplayType: 'Dollar',
      metricType: 'Stratified Median Value (monthly)',
      metricTypeDescription: 'Statistics are calculated at the end of the displayed month',
      metricTypeId: 73,
      propertyType: 'Residential dwellings',
      changePercentage: '16.8%',
      seriesDataList: [{
        dateTime: '2015-09-30',
        value: 289250.0
      }, {
        dateTime: '2015-10-31',
        value: 293000.0
      }, {
        dateTime: '2015-11-30',
        value: 297850.0
      }, {
        dateTime: '2015-12-31',
        value: 297550.0
      }, {
        dateTime: '2016-01-31',
        value: 300800.0
      }, {
        dateTime: '2016-02-29',
        value: 303650.0
      }, {
        dateTime: '2016-03-31',
        value: 305050.0
      }, {
        dateTime: '2016-04-30',
        value: 306650.0
      }, {
        dateTime: '2016-05-31',
        value: 308500.0
      }, {
        dateTime: '2016-06-30',
        value: 310450.0
      }, {
        dateTime: '2016-07-31',
        value: 308800.0
      }, {
        dateTime: '2016-08-31',
        value: 305700.0
      }, {
        dateTime: '2016-09-30',
        value: 306600.0
      }, {
        dateTime: '2016-10-31',
        value: 308550.0
      }, {
        dateTime: '2016-11-30',
        value: 311450.0
      }, {
        dateTime: '2016-12-31',
        value: 309050.0
      }, {
        dateTime: '2017-01-31',
        value: 313050.0
      }, {
        dateTime: '2017-02-28',
        value: 313950.0
      }, {
        dateTime: '2017-03-31',
        value: 313800.0
      }, {
        dateTime: '2017-04-30',
        value: 313800.0
      }, {
        dateTime: '2017-05-31',
        value: 315000.0
      }, {
        dateTime: '2017-06-30',
        value: 319600.0
      }, {
        dateTime: '2017-07-31',
        value: 319800.0
      }, {
        dateTime: '2017-08-31',
        value: 317900.0
      }, {
        dateTime: '2017-09-30',
        value: 317500.0
      }, {
        dateTime: '2017-10-31',
        value: 314050.0
      }, {
        dateTime: '2017-11-30',
        value: 314500.0
      }, {
        dateTime: '2017-12-31',
        value: 307050.0
      }, {
        dateTime: '2018-01-31',
        value: 304200.0
      }, {
        dateTime: '2018-02-28',
        value: 306150.0
      }, {
        dateTime: '2018-03-31',
        value: 307700.0
      }, {
        dateTime: '2018-04-30',
        value: 307700.0
      }, {
        dateTime: '2018-05-31',
        value: 308950.0
      }, {
        dateTime: '2018-06-30',
        value: 309950.0
      }, {
        dateTime: '2018-07-31',
        value: 309500.0
      }, {
        dateTime: '2018-08-31',
        value: 311350.0
      }, {
        dateTime: '2018-09-30',
        value: 314650.0
      }, {
        dateTime: '2018-10-31',
        value: 315100.0
      }, {
        dateTime: '2018-11-30',
        value: 315800.0
      }, {
        dateTime: '2018-12-31',
        value: 317550.0
      }, {
        dateTime: '2019-01-31',
        value: 320050.0
      }, {
        dateTime: '2019-02-28',
        value: 322350.0
      }, {
        dateTime: '2019-03-31',
        value: 324250.0
      }, {
        dateTime: '2019-04-30',
        value: 325850.0
      }, {
        dateTime: '2019-05-31',
        value: 327800.0
      }, {
        dateTime: '2019-06-30',
        value: 327450.0
      }, {
        dateTime: '2019-07-31',
        value: 325800.0
      }, {
        dateTime: '2019-08-31',
        value: 326500.0
      }, {
        dateTime: '2019-09-30',
        value: 322900.0
      }, {
        dateTime: '2019-10-31',
        value: 324750.0
      }, {
        dateTime: '2019-11-30',
        value: 321100.0
      }, {
        dateTime: '2019-12-31',
        value: 327350.0
      }, {
        dateTime: '2020-01-31',
        value: 327550.0
      }, {
        dateTime: '2020-02-29',
        value: 329950.0
      }, {
        dateTime: '2020-03-31',
        value: 330800.0
      }, {
        dateTime: '2020-04-30',
        value: 330350.0
      }, {
        dateTime: '2020-05-31',
        value: 332350.0
      }, {
        dateTime: '2020-06-30',
        value: 333100.0
      }, {
        dateTime: '2020-07-31',
        value: 334700.0
      }, {
        dateTime: '2020-08-31',
        value: 337750.0
      }]
    }]
  }
}

export {
  PREVIEW_DATA_REPORT_AU,
  PREVIEW_DATA_REPORT_NZ,
  PREVIEW_DATA_MAP_PANEL,
  PREVIEW_DATA_VALUATION_ESTIMATE_AU,
  PREVIEW_DATA_VALUATION_ESTIMATE_NZ,
  PREVIEW_DATA_PROPERTY_SUMMARY_AU,
  PREVIEW_DATA_PROPERTY_SUMMARY_NZ,
  PREVIEW_DATA_PROPERTY_TIMELINE_AU,
  PREVIEW_DATA_PROPERTY_TIMELINE_NZ,
  PREVIEW_DATA_DISCLAIMER_AU,
  PREVIEW_DATA_DISCLAIMER_NZ,
  PREVIEW_DATA_COPYRIGHT,
  PREVIEW_DATA_LOCAL_SCHOOL,
  PREVIEW_DATA_RATING_VALUATION,
  PREVIEW_DATA_TITLE_DETAIL,
  PREVIEW_DATA_MARKET_INSIGHT_AU,
  PREVIEW_DATA_MARKET_INSIGHT_NZ,
  PREVIEW_DATA_MARKET_INSIGHT_1YR_AU,
  PREVIEW_DATA_MARKET_INSIGHT_1YR_NZ,
  PREVIEW_DATA_PHOTO_LIST,
  PREVIEW_DATA_COMPARABLES_AU,
  PREVIEW_DATA_COMPARABLES_NZ
}
